export default "__VITE_ASSET__SQDzPMuo__"